export interface IOpoContactPosition {
    id: number,
    description: string
}

export interface IOpoContact {
    id: number,
    firstName: string,
    lastName: string,
    title: string,
    email: string,
    officePhone: string,
    mobilePhone: string,
    positions: IOpoContactPosition[],
    isPortalUser: boolean
}

export interface IOpoContactRequest {
    firstName: string,
    lastName: string,
    title: string,
    email: string,
    officePhone: string,
    mobilePhone: string,
    positions: number[]
}

export interface IOpoContactsData {
    contacts: IOpoContact[],
    positions: IOpoContactPosition[],
    canManage: boolean
}
